"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiDictionary = exports.DataEdge = exports.VectView = exports.Vect = exports.VectBase = exports.DataLine = exports.DataLineView = exports.Dataset = exports.FeatureType = exports.DatasetType = exports.getSegs = exports.InferCategory = exports.Preprocessor = exports.DatasetDatabase = void 0;
const meshes_1 = require("../WebGLView/meshes");
const ChessFingerprint_1 = require("../legends/ChessFingerprint/ChessFingerprint");
const RubikFingerprint_1 = require("../legends/RubikFingerprint/RubikFingerprint");
var d3v5 = require('d3');
const DEFAULT_LINE = "L";
const DEFAULT_ALGO = "all";
var PrebuiltFeatures;
(function (PrebuiltFeatures) {
    PrebuiltFeatures["Line"] = "line";
})(PrebuiltFeatures || (PrebuiltFeatures = {}));
/**
 * Dummy class that holds information about the files that can be preselected.
 */
class DatasetDatabase {
    constructor() {
        this.data = [
            {
                display: "Synthetic Stories t-SNE",
                path: "datasets/story/new_artificial_tSNE_now.csv",
                type: DatasetType.Story
            },
            {
                display: "Synthetic Stories MDS",
                path: "datasets/story/new_artificial_MDS_now.csv",
                type: DatasetType.Story
            },
            {
                display: "Synthetic Stories UMAP",
                path: "datasets/story/new_artificial_UMAP_now.csv",
                type: DatasetType.Story
            },
            {
                display: "Synthetic Stories (Data Type) t-SNE",
                path: "datasets/story/new_our_artificial_tSNE_now.csv",
                type: DatasetType.Story
            },
            {
                display: "Synthetic Stories (Data Type) t-SNE (wnum=5)",
                path: "datasets/story/new_our_artificial_tSNE_wy5.csv",
                type: DatasetType.Story
            },
            {
                display: "Synthetic Stories (Data Type) MDS",
                path: "datasets/story/new_our_artificial_MDS_now.csv",
                type: DatasetType.Story
            },
            {
                display: "Synthetic Stories (Data Type) UMAP",
                path: "datasets/story/new_our_artificial_UMAP_now.csv",
                type: DatasetType.Story
            },
            {
                display: "Actual User Sessions t-SNE",
                path: "datasets/story/new_stories_tSNE_now.csv",
                type: DatasetType.Story
            },
            {
                display: "Actual User Sessions MDS",
                path: "datasets/story/new_stories_MDS_now.csv",
                type: DatasetType.Story
            },
            {
                display: "Actual User Sessions UMAP",
                path: "datasets/story/new_stories_UMAP_now.csv",
                type: DatasetType.Story
            }
        ];
    }
    getTypes() {
        return [...new Set(this.data.map(value => value.type))];
    }
    getByPath(path) {
        return this.data.filter(e => e.path == path)[0];
    }
}
exports.DatasetDatabase = DatasetDatabase;
/**
 * Class that preprocesses the data set and checks for validity.
 * Will halucinate attributes like x, y, line, algo and multiplicity if
 * they are not present.
 */
class Preprocessor {
    constructor(vectors) {
        this.vectors = vectors;
    }
    /**
     * Returns an array of columns that are available in the vectors
     */
    getColumns() {
        var vector = this.vectors[0];
        return Object.keys(vector).filter(e => e != '__meta__');
    }
    /**
     * Returns a unique array of distinct line values.
     */
    distinctLines() {
        if (this.getColumns().includes("line")) {
            return [...new Set(this.vectors.map(vector => vector.line))];
        }
        else {
            return [];
        }
    }
    /**
     * Infers the multiplicity attribute for this dataset.
     */
    inferMultiplicity() {
        if (this.getColumns().includes('multiplicity') || !this.getColumns().includes('x') || !this.getColumns().includes('y')) {
            return;
        }
        var distinctLines = this.distinctLines();
        if (distinctLines.length > 0) {
            // Build line pools
            var linePools = {};
            this.distinctLines().forEach(line => {
                // Dictionary holding the x/y values of the line
                linePools[line] = {};
            });
            // Builds x attributes for linepools
            this.vectors.forEach(vector => {
                linePools[vector.line][vector.x] = {};
            });
            var distinctLines = this.distinctLines();
            // Count multiplicities
            this.vectors.forEach(vector => {
                distinctLines.forEach(line => {
                    if (linePools[line][vector.x] != null) {
                        if (linePools[line][vector.x][vector.y] == null) {
                            linePools[line][vector.x][vector.y] = 1;
                        }
                        else {
                            linePools[line][vector.x][vector.y] = linePools[line][vector.x][vector.y] + 1;
                        }
                    }
                });
            });
            // Apply multiplicities
            this.vectors.forEach(vector => {
                vector.multiplicity = linePools[vector.line][vector.x][vector.y];
            });
        }
        else {
            let pool = {};
            this.vectors.forEach(sample => {
                if (sample.x in pool) {
                    pool[sample.x][sample.y] = pool[sample.x][sample.y] + 1;
                }
                else {
                    let o = {};
                    pool[sample.x] = o;
                    o[sample.y] = 1;
                }
            });
            this.vectors.forEach(sample => {
                sample.multiplicity = pool[sample.x][sample.y];
            });
        }
    }
    preprocess(ranges) {
        this.inferMultiplicity();
        var vectors = this.vectors;
        var header = Object.keys(vectors[0]);
        // If data contains no x and y attributes, its invalid
        if (header.includes("x") && header.includes("y")) {
            vectors.forEach(vector => {
                vector.x = +vector.x;
                vector.y = +vector.y;
            });
        }
        else {
            // In case we are missing x and y columns, we can just generate a uniformly distributed point cloud
            vectors.forEach(vector => {
                vector.x = (Math.random() - 0.5) * 100;
                vector.y = (Math.random() - 0.5) * 100;
            });
        }
        // If data contains no line attribute, add one
        if (header.includes("line") && !header.includes("age")) {
            var segs = {};
            var distinct = [...new Set(vectors.map(vector => vector.line))];
            distinct.forEach(a => segs[a] = 0);
            vectors.forEach(vector => {
                //vector.age = segs[vector.line]
                segs[vector.line] = segs[vector.line] + 1;
            });
            var cur = {};
            distinct.forEach(a => cur[a] = 0);
            vectors.forEach(vector => {
                vector.age = cur[vector.line] / segs[vector.line];
                cur[vector.line] = cur[vector.line] + 1;
            });
            ranges["age"] = { min: 0, max: 1 };
        }
        // If data has no algo attribute, add DEFAULT_ALGO
        if (!header.includes("algo")) {
            vectors.forEach(vector => {
                vector.algo = DEFAULT_ALGO;
            });
        }
        vectors.forEach(function (d) {
            if ("age" in d) {
                d.age = +d.age;
            }
        });
        // If data has no cluster labels, add default ones
        if (!header.includes('clusterLabel')) {
            vectors.forEach(vector => {
                vector.clusterLabel = [];
                vector.clusterProbability = 0.0;
            });
        }
        else {
            // Support multivariate points ... eg each clusterLabel is actually an array
            vectors.forEach(vector => {
                try {
                    if (isNaN(vector.clusterLabel)) {
                        // convert string to array
                        vector.clusterLabel = JSON.parse(vector.clusterLabel);
                    }
                    else {
                        if (vector.clusterLabel < 0) {
                            vector.clusterLabel = [];
                        }
                        else {
                            // convert number to array
                            vector.clusterLabel = [vector.clusterLabel];
                        }
                    }
                }
                catch (_a) {
                    // default is empty array
                    vector.clusterLabel = [];
                }
            });
        }
        return ranges;
    }
}
exports.Preprocessor = Preprocessor;
/**
 * Object responsible for infering things from the data structure of a csv file.
 * For example this class can infer the
 * - ranges of columns
 * - type of data file (rubik, story...)
 */
class InferCategory {
    constructor(vectors) {
        this.vectors = vectors;
    }
    /**
     * Infers the type of the dataset from the columns
     * @param {*} header
     */
    inferType() {
        var header = Object.keys(this.vectors[0]);
        // Checks if the header has all the required columns
        const hasLayout = (header, columns) => {
            for (let key in columns) {
                let val = columns[key];
                if (!header.includes(val)) {
                    return false;
                }
            }
            return true;
        };
        if (hasLayout(header, RubikFingerprint_1.requiredRubikColumns)) {
            return DatasetType.Rubik;
        }
        if (header.includes('cf00')) {
            return DatasetType.Neural;
        }
        if (hasLayout(header, ChessFingerprint_1.requiredChessColumns)) {
            return DatasetType.Chess;
        }
        if (header.includes('new_y')) {
            return DatasetType.Story;
        }
        if (header.includes('aa')) {
            return DatasetType.Go;
        }
        return DatasetType.None;
    }
    /**
     * Infers an array of attributes that can be filtered after, these can be
     * categorical, sequential or continuous attribues.
     * @param {*} ranges
     */
    load(ranges) {
        if (this.vectors.length <= 0) {
            return [];
        }
        var options = [
            {
                "category": "shape",
                "attributes": []
            },
            {
                "category": "size",
                "attributes": []
            },
            {
                "category": "transparency",
                "attributes": []
            },
            {
                "category": "color",
                "attributes": []
            }
        ];
        var header = Object.keys(this.vectors[0]).filter(a => a != "line");
        header.forEach(key => {
            // Check for given header key if its categorical, sequential or diverging
            var distinct = [...new Set(this.vectors.map(vector => vector[key]))];
            if (distinct.length > 8 || key in ranges || key == 'multiplicity') {
                // Check if values are numeric
                if (!distinct.find(value => isNaN(value))) {
                    // If we have a lot of different values, the values or probably sequential data
                    var category = options.find(e => e.category == "color");
                    var min = null, max = null;
                    if (key in ranges) {
                        min = ranges[key].min;
                        max = ranges[key].max;
                    }
                    else {
                        min = Math.min(...distinct);
                        max = Math.max(...distinct);
                    }
                    category.attributes.push({
                        "key": key,
                        "name": key,
                        "type": "sequential",
                        "range": {
                            "min": min,
                            "max": max
                        }
                    });
                    options.find(e => e.category == "transparency").attributes.push({
                        "key": key,
                        "name": key,
                        "type": "sequential",
                        "range": {
                            "min": min,
                            "max": max
                        },
                        "values": {
                            range: [0.3, 1.0]
                        }
                    });
                    options.find(e => e.category == "size").attributes.push({
                        "key": key,
                        "name": key,
                        "type": "sequential",
                        "range": {
                            "min": min,
                            "max": max
                        },
                        "values": {
                            range: [1, 2]
                        }
                    });
                }
            }
            else {
                if (distinct.find(value => isNaN(value)) || key == 'algo') {
                    options.find(e => e.category == 'color').attributes.push({
                        "key": key,
                        "name": key,
                        "type": "categorical"
                    });
                    if (distinct.length <= 4) {
                        var shapes = ["star", "cross", "circle", "square"];
                        options.find(e => e.category == 'shape').attributes.push({
                            "key": key,
                            "name": key,
                            "type": "categorical",
                            "values": distinct.map((value, index) => {
                                return {
                                    from: value,
                                    to: shapes[index]
                                };
                            })
                        });
                    }
                }
            }
        });
        return options;
    }
}
exports.InferCategory = InferCategory;
function getSegs(vectors) {
    // Get a list of lines that are in the set
    var lineKeys = [...new Set(vectors.map(vector => vector.line))];
    var segments = lineKeys.map(lineKey => {
        var l = new DataLine(lineKey, vectors.filter(vector => vector.line == lineKey).sort((a, b) => a.age - b.age));
        // Set segment of vectors
        l.vectors.forEach((v, vi) => {
            v.view.segment = l;
            v.view.sequenceIndex = vi;
        });
        return l;
    });
    return segments;
}
exports.getSegs = getSegs;
var DatasetType;
(function (DatasetType) {
    DatasetType[DatasetType["Rubik"] = 0] = "Rubik";
    DatasetType[DatasetType["Chess"] = 1] = "Chess";
    DatasetType[DatasetType["Neural"] = 2] = "Neural";
    DatasetType[DatasetType["Go"] = 3] = "Go";
    DatasetType[DatasetType["Test"] = 4] = "Test";
    DatasetType[DatasetType["Story"] = 5] = "Story";
    DatasetType[DatasetType["Coral"] = 6] = "Coral";
    DatasetType[DatasetType["None"] = 7] = "None";
})(DatasetType = exports.DatasetType || (exports.DatasetType = {}));
var FeatureType;
(function (FeatureType) {
    FeatureType[FeatureType["Categorical"] = 0] = "Categorical";
    FeatureType[FeatureType["Quantitative"] = 1] = "Quantitative";
    FeatureType[FeatureType["Date"] = 2] = "Date";
})(FeatureType = exports.FeatureType || (exports.FeatureType = {}));
/**
 * Dataset class that holds all data, the ranges and additional stuff
 */
class Dataset {
    constructor(vectors, ranges, preselection, info, featureTypes) {
        this.mapProjectionInitialization = entry => {
            return {
                name: entry,
                checked: entry[0] === '*'
            };
        };
        this.vectors = vectors;
        this.ranges = ranges;
        this.info = info;
        this.columns = {};
        this.type = this.info.type;
        this.calculateBounds();
        this.calculateColumnTypes(ranges, featureTypes);
        this.checkLabels();
        // If the dataset is sequential, calculate the segments
        this.isSequential = this.checkSequential();
        if (this.isSequential) {
            this.segments = getSegs(this.vectors);
        }
        this.preselectedProjectionColumns = preselection;
    }
    inferRangeForAttribute(key) {
        let values = this.vectors.map(sample => sample[key]);
        let numeric = true;
        let min = Number.MAX_SAFE_INTEGER;
        let max = Number.MIN_SAFE_INTEGER;
        values.forEach(value => {
            if (isNaN(value)) {
                numeric = false;
            }
            else if (numeric) {
                if (value < min) {
                    min = value;
                }
                else if (value > max) {
                    max = value;
                }
            }
        });
        return numeric ? { min: min, max: max, inferred: false } : null;
    }
    reloadRanges() {
    }
    // Checks if the dataset contains sequential data
    checkSequential() {
        var header = this.getColumns();
        // If we have no line attribute, its not sequential
        if (!header.includes(PrebuiltFeatures.Line)) {
            return false;
        }
        // If each sample is a different line, its not sequential either
        var set = new Set(this.vectors.map(vector => vector.line));
        return set.size != this.vectors.length;
    }
    checkLabels() {
        this.multivariateLabels = false;
        this.vectors.forEach(vector => {
            if (vector.clusterLabel.length > 1) {
                this.multivariateLabels = true;
                return;
            }
        });
    }
    /**
     * Creates a map which shows the distinct types and data types of the columns.
     */
    calculateColumnTypes(ranges, featureTypes) {
        var columnNames = Object.keys(this.vectors[0]);
        columnNames.forEach(columnName => {
            this.columns[columnName] = {};
            this.columns[columnName].featureType = featureTypes[columnName];
            // Check data type
            if (columnName in ranges) {
                this.columns[columnName].range = ranges[columnName];
            }
            else {
                if (this.vectors.find(vector => isNaN(vector[columnName]))) {
                    this.columns[columnName].distinct = Array.from(new Set([...this.vectors.map(vector => vector[columnName])]));
                    this.columns[columnName].isNumeric = false;
                }
                else {
                    this.columns[columnName].isNumeric = true;
                    this.columns[columnName].range = this.inferRangeForAttribute(columnName);
                }
            }
        });
        if ('algo' in this.columns)
            this.columns['algo'].featureType = FeatureType.Categorical;
        if ('clusterLabel' in this.columns)
            this.columns['clusterLabel'].featureType = FeatureType.Categorical;
        if ('clusterProbability' in this.columns)
            this.columns['clusterProbability'].featureType = FeatureType.Quantitative;
        if ('x' in this.columns)
            this.columns['x'].featureType = FeatureType.Quantitative;
        if ('y' in this.columns)
            this.columns['y'].featureType = FeatureType.Quantitative;
    }
    /**
     * Returns an array of columns that are available in the vectors
     */
    getColumns() {
        var vector = this.vectors[0];
        return Object.keys(vector).filter(e => e != '__meta__');
    }
    /**
     * Returns true if the dataset contains the column.
     */
    hasColumn(column) {
        return this.getColumns().find(e => e == column) != undefined;
    }
    /**
     * Returns the vectors in this dataset as a 2d array, which
     * can be used as input for tsne for example.
     */
    asTensor(columns, samples) {
        var tensor = [];
        function oneHot(n, length) {
            var arr = new Array(length).fill(0);
            arr[n] = 1;
            return arr;
        }
        (samples !== null && samples !== void 0 ? samples : this.vectors).forEach(vector => {
            var data = [];
            columns.forEach(entry => {
                let column = entry.name;
                if (this.columns[column].isNumeric) {
                    // Numeric data can just be appended to the array
                    if (column in this.ranges) {
                        let abs = Math.max(Math.abs(this.ranges[column].min), Math.abs(this.ranges[column].max));
                        data.push(+vector[column] / abs);
                    }
                    else {
                        data.push(+vector[column]);
                    }
                }
                else {
                    // Not numeric data can be converted using one-hot encoding
                    data = data.concat(oneHot(this.columns[column].distinct.indexOf(vector[column]), this.columns[column].distinct.length));
                }
            });
            tensor.push(data);
        });
        return tensor;
    }
    /**
     * Calculates the dataset bounds for this set, eg the minimum and maximum x,y values
     * which is needed for the zoom to work correctly
     */
    calculateBounds() {
        var xAxis = this.vectors.map(vector => vector.x);
        var yAxis = this.vectors.map(vector => vector.y);
        var minX = Math.min(...xAxis);
        var maxX = Math.max(...xAxis);
        var minY = Math.min(...yAxis);
        var maxY = Math.max(...yAxis);
        var scaleBase = 100;
        var absoluteMaximum = Math.max(Math.abs(minX), Math.abs(maxX), Math.abs(minY), Math.abs(maxY));
        this.bounds = {
            scaleBase: scaleBase,
            scaleFactor: absoluteMaximum / scaleBase,
            x: {
                min: minX,
                max: maxX
            },
            y: {
                min: minY,
                max: maxY
            }
        };
    }
    /**
     * Calculates the maximum path length for this dataset.
     */
    getMaxPathLength() {
        if (this.isSequential) {
            return Math.max(...this.segments.map(segment => segment.vectors.length));
        }
        else {
            return 1;
        }
    }
}
exports.Dataset = Dataset;
/**
 * View information for segments
 */
class DataLineView {
    constructor() {
        /**
         * Determines if this line should be grayed out
         */
        this.grayed = false;
        /**
         * Is this segment visible through the detailed selection? (line selection treeview)
         */
        this.detailVisible = true;
        /**
         * Is this segment visible through the global switch?
         */
        this.globalVisible = true;
        /**
         * Is this segment currently highlighted?
         */
        this.highlighted = false;
        /**
         * Color set for this line
         */
        this.intrinsicColor = null;
        /**
         * Line mesh
         */
        this.lineMesh = null;
    }
}
exports.DataLineView = DataLineView;
/**
 * Main data class for lines
 */
class DataLine {
    constructor(lineKey, vectors) {
        this.lineKey = lineKey;
        this.vectors = vectors;
        this.__meta__ = {};
        this.setMeta('view', new DataLineView());
    }
    /**
     * Sets some meta data for a key
     */
    setMeta(key, value) {
        this.__meta__[key] = value;
    }
    /**
     * Gets some meta data for a key
     */
    getMeta(key) {
        return this.__meta__[key];
    }
    /**
     * Getter for view details
     */
    get view() {
        return this.getMeta('view');
    }
}
exports.DataLine = DataLine;
/**
 * Math class for vector calculations.
 */
class VectBase {
    constructor(x, y) {
        this.x = x;
        this.y = y;
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        return this;
    }
    angle() {
        return Math.atan2(-this.y, -this.x) + Math.PI;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        return this;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    static subtract(a, b) {
        return new VectBase(a.x - b.x, a.y - b.y);
    }
    static add(a, b) {
        return new VectBase(a.x + b.x, a.y + b.y);
    }
}
exports.VectBase = VectBase;
/**
 * Main data class for points
 */
class Vect {
    constructor(dict) {
        // Copy dictionary values to this object
        Object.keys(dict).forEach(key => {
            this[key] = dict[key];
        });
        this.__meta__ = {};
        this.setMeta('view', new VectView());
    }
    /**
     * Sets some meta data for a key
     */
    setMeta(key, value) {
        this.__meta__[key] = value;
    }
    /**
     * Gets some meta data for a key
     */
    getMeta(key) {
        return this.__meta__[key];
    }
    /**
     * Getter for view details
     */
    get view() {
        return this.getMeta('view');
    }
    pureValues() {
        var keys = this.pureHeader();
        return keys.map(key => this[key]);
    }
    pureHeader() {
        return Object.keys(this).filter(value => value != '__meta__');
    }
}
exports.Vect = Vect;
/**
 * View information for a vector, this contains all attributes that are not data related, for
 * example the color or the index to the mesh vertex
 */
class VectView {
    constructor() {
        /**
         * Index to the vertice from three
         */
        this.meshIndex = -1;
        /**
         * Is this vector selected?
         */
        this.selected = false;
        /**
         * The segment reference this vector belongs to.
         */
        this.segment = null;
        /**
         * Index of sequence from 0 to n, this is needed because the key for the line might be sortable, but not numeric
         */
        this.sequenceIndex = -1;
        /**
         * Set color for this vertice, if null the color of the line is taken
         */
        this.intrinsicColor = null;
        /**
         * Is this vector visible?
         */
        this.visible = true;
        /**
         * Currently displayed shape of the vector.
         */
        this.shapeType = meshes_1.Shapes.Circle;
        /**
         * Base size scaling for this point
         */
        this.baseSize = 16;
        this.highlighted = false;
        this.duplicateOf = null;
        // Brightness value of this sample.
        this.brightness = 1.0;
        // Is this point grayed out
        // If this value is null the grayed value will be taken from the segment
        this.grayed = null;
    }
}
exports.VectView = VectView;
/**
 * A class representing a single edge of a DataLine. It has 2 points
 * and specifies the direction of this line part.
 */
class DataEdge {
    constructor(source, target) {
        this.source = source;
        this.target = target;
        this.view = {};
    }
}
exports.DataEdge = DataEdge;
/**
 * Helper class for structured dictionary data.
 * { key1: [], key2: [] ... }
 */
class MultiDictionary {
    constructor() {
        this.data = [];
        this.lookup = {};
    }
    insert(key, value) {
        if (key in this.lookup) {
            // If key is in lookup, add value to array
            this.data[this.lookup[key]].push(value);
        }
        else {
            // If key is not in lookup, store lookup index and add array
            this.lookup[key] = this.data.length;
            this.data.push([value]);
        }
    }
    /**
     * Matrix representation is just the data array.
     */
    toMatrix() {
        return this.data;
    }
}
exports.MultiDictionary = MultiDictionary;
